// extracted by mini-css-extract-plugin
module.exports = {"shareLink":"_2yH5Y","shareIcon":"_1qklg"};